<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h3 style="padding-top:0">Weaving Draft</h3>
        <div v-if='authUser'>{{ authUser.Name }}, {{ draftId }}</div>

        <div v-if='sampleDraftJSON'>
            <draft-read-only :sampleDraftJSON = 'sampleDraftJSON' :cellPixelSize = 'cellPixelSize' :showLines = 'true' :showReverse = 'false' />
        </div>

    </b-container>
</template>

<script>

import draftReadOnly from './DraftReadOnly.vue'
import dataService from '../mixins/dataService.js'

export default {
    mixins: [dataService],
    components: {
        draftReadOnly: draftReadOnly
    },
    data: function() {
        return {
            draftId: 0,
            isStraightThreading: false,
            isStraightTreadling: false,
            isPointThreading: false,
            isPointTreadling: false,
            isTurned: false,
            sampleDraftJSON: null,
            cellPixelSize: 2
        }
    },
    methods: {
        loadDraftData(source) {
            console.log('in loadDraftData, source: ' + source + ' isAutenticated: ' + this.isAuthenticated + 'this.$route.params.id: ' + this.$route.params.id)

            if (this.isAuthenticated && this.$route.params.id) {
                this.draftId = this.$route.params.id
                this.getPatternJson(this.draftId, this.isStraightThreading, this.isStraightTreadling, this.isPointThreading, this.isPointTreadling, this.isTurned, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.sampleDraftJSON = JSON.stringify(resp.data)
                    // console.log('Draft Data: ' + JSON.stringify(this.sampleDraft))
                    this.$store.commit('setPageTitle', 'Weaving Draft Editor')
                })
            }
        }
    },

    watch: {
        '$route.params.id': function() {
            this.loadDraftData('watch route id')
        },
        'authUser': function() {
            this.loadDraftData('watch auth user')
        }
    },

    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        authUser: function() {
            return this.$store.state.authUser
        }
    },
    created() {
        this.loadDraftData('created')
    },
    mounted() {
        this.loadDraftData('mounted')
    },
    updated() {
        this.loadDraftData('updated')
    }
}
</script>




// WEBPACK FOOTER //
// src/components/DraftViewTest.vue